import axios from 'axios';
import {useMutation} from 'react-query';

interface ForgetPassword {
    email:string,
}

export const useForgetPassword = () => {
    const forgetPassword = async (values: ForgetPassword) => {
        const baseURL = process.env.REACT_APP_BASE_URL;
        // return await axios.post(`${baseURL}/wp-json/api/user/retrieve_password?${queryString}&insecure=cool`);
        return await axios.post(`${baseURL}/wp-json/bdpwr/v1/reset-password`, values);
    };
    return useMutation('forget-password', forgetPassword);
};

export default useForgetPassword;
